export default __webpack_public_path__ + "static/media/AboutUs_Vid.900798e9.mp4";